( function () {
    'use strict';
    ( function ( $ ) {
        function slick_hlboxes(){
            var wrapper_hl= $(".hl-boxes");
            if(window.innerWidth >= 768) {
                if (wrapper_hl.hasClass('slick-initialized')) {
                    wrapper_hl.slick('unslick');
                }
            }
            else{
                if (!wrapper_hl.hasClass('slick-initialized')) {
                    wrapper_hl.slick({
                        slideToShow: 1,
                        slidesToScroll: 1,
                        autoplay: false,
                        autoplaySpeed: 4000,
                        infinite: true,
                        arrows: true,
                        rows: 0,
                        mobileFirst: true,
                        responsive: [
                            {
                              breakpoint: 767,
                              settings: "unslick"
                            },                
                        ]
                    });
                }
            }
        }
        slick_hlboxes();
        $(window).resize(slick_hlboxes);
    } )( jQuery );
} )();